import { EyeOutlined } from "@ant-design/icons";

// Hàm format số
export const numberFormat = (number: any) => {
    let result;
    if (typeof number === "number") {
        result = new Intl.NumberFormat().format(number);
    } else {
        result = number;
    }
    return result;
};

export const getReportColumns = (onStaffClick: (record: any) => void) => [
    {
        title: "Bank",
        dataIndex: "addbank",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Profit machine",
        dataIndex: "profit",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Money of system",
        dataIndex: "money_of_system",
        align: "right" as const,
        render: (text: any, record: any) => (
            <span>{numberFormat(record.money_of_system)}</span>
        ),
    },
    {
        title: "Cash on hand",
        dataIndex: "money_in_proof",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Loss",
        align: "right" as const,
        render: (_: any, record: any) => <span>{numberFormat(record.loss)}</span>,
    },
    {
        title: "Final",
        dataIndex: "final",
        align: "right" as const,
        render: (_: any, record: any) => {
            const finalNumber = record.money_of_system - record.addbank;
            return (
                <span style={{ color: finalNumber < 0 ? "#FD8181" : "#55c790" }}>
                    {numberFormat(finalNumber)}
                </span>
            );
        },
    },
    {
        title: "Date",
        dataIndex: "date",
    },
    {
        title: "Staff Report",
        dataIndex: "staff",
        render: (_: string, record: any) => (
            <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => onStaffClick(record)}
            >
                <span>{record.staff}</span>{" "}
                <EyeOutlined style={{ fontSize: 16, verticalAlign: "middle" }} />
            </span>
        ),
    },
    {
        title: "Bonus",
        dataIndex: "bonus_total",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Labor",
        dataIndex: "labor",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Match",
        dataIndex: "match_total",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Extra",
        dataIndex: "extra",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
    {
        title: "Payout of system",
        dataIndex: "payout_total",
        align: "right" as const,
        render: (text: any) => <span>{numberFormat(text)}</span>,
    },
];

export const detailColumns = [
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
    },
    {
        title: 'Staff',
        dataIndex: 'staff',
        key: 'staff',
        render: (text: string) => (
            <span>{text}</span>
        )
    },
    {
        title: 'Start',
        dataIndex: 'start_amount',
        key: 'start_amount',
        render: (text: any, record: any) => (
            <span>{(text)}</span>
        )
    },
    {
        title: 'Add bank',
        dataIndex: 'addbank',
        key: 'addbank',
        render: (text: any) => (
            <span>{(text)}</span>
        )
    },
    {
        title: 'Match',
        dataIndex: 'match_total',
        key: 'match_total',
        align: 'right' as const,
        render: (text: any) => (
            <span>{(text)}</span>
        )
    },
    {
        title: 'Pay out',
        dataIndex: 'payout_total',
        key: 'payout_total',
        align: 'right' as const,
        render: (text: any) => (
            <span >{(text)}</span>
        )
    },
    {
        title: 'Bonus',
        dataIndex: 'bonus_amount',
        key: 'bonus_amount',
        align: 'right' as const,
        render: (text: any) => (
            <span >{(text)}</span>
        )
    },
    {
        title: 'Extra',
        dataIndex: 'extra_amount',
        key: 'extra_amount',
        align: 'right' as const,
        render: (text: any) => (
            <span >{(text)}</span>
        )
    },
    {
        title: 'Cash on hand',
        dataIndex: 'money_proof',
        key: 'money_proof',
        align: 'right' as const,
        render: (text: any) => (
            <span >{(text)}</span>
        )
    },
    {
        title: 'Final',
        dataIndex: 'final',
        key: 'final',
        align: 'right' as const,
        render: (text: any) => (
            <span >{(text)}</span>
        )
    },
];

export const matchColumns = [
    {
        title: "No.",
        key: "stt",
        width: 70,
        align: "center" as const,
        render: (_: any, __: any, index: number) => index + 1,
    },
    {
        title: "App ID",
        dataIndex: "app_id",
        key: "app_id",
    },
    {
        title: "Customer name",
        dataIndex: "customer_name",
        key: "customer_name",
    },
    {
        title: "Phone number",
        dataIndex: "phone_number",
        key: "phone_number",
    },
    {
        title: "Shift",
        dataIndex: "shift",
        key: "shift",
    },
    {
        title: "Machine",
        dataIndex: "machine_number",
        key: "machine_number",
    },
    {
        title: "Time",
        key: "time",
        render: (_: any, record: any) => (
            <span>
                {record.time_checkin}
                {record.date_checkin ? (
                    <span style={{ color: "#888", marginLeft: 8 }}>
                        ({record.date_checkin})
                    </span>
                ) : null}
            </span>
        ),
    },
    {
        title: "Level",
        dataIndex: "level",
        key: "level",
        align: "right" as const,
        render: (text: any) => <span>{text}</span>,
    },
    {
        title: "Role",
        dataIndex: "role_name",
        key: "role_name",
        align: "right" as const,
    },
    {
        title: "Match",
        dataIndex: "match_amount",
        key: "match_amount",
        align: "right" as const,
    },
    {
        title: "Cashout",
        dataIndex: "cash_out",
        key: "cash_out",
        align: "right" as const,
    },
];

export const payoutVoucherColumns = [
    {
        title: "Time",
        dataIndex: "timecashout",
        key: "timecashout",
    },
    {
        title: "Staff",
        dataIndex: "staff_name",
        key: "staff_name",
    },
    {
        title: "Cash-out",
        dataIndex: "match_amount",
        key: "match_amount",
        render: (value: any) => <span>{Number(value).toLocaleString()}</span>,
    },
    {
        title: "Machine",
        dataIndex: "machine_number",
        key: "machine_number",
    },
];

export const bonusColumns = [
    {
        title: "Time",
        dataIndex: "time",
        key: "time",
    },
    {
        title: "Staff",
        dataIndex: "staff_name",
        key: "staff_name",
    },
    {
        title: "Cash-Out",
        dataIndex: "cashOut",
        key: "cashOut",
        render: (value: any) => <span>{Number(value).toLocaleString()}</span>,
    },
    {
        title: "Machine",
        dataIndex: "machine",
        key: "machine",
    },
    {
        title: "Photo",
        dataIndex: "photo",
        key: "photo",
        render: (value: string) =>
            value ? (
                <img src={value} alt="photo" style={{ width: 48, height: 48, objectFit: "cover" }} />
            ) : null,
    },
];

export const manualPayoutColumns = [
    {
        title: "Time",
        dataIndex: "time",
        key: "time",
    },
    {
        title: "Staff",
        dataIndex: "staff_name",
        key: "staff_name",
    },
    {
        title: "Cash-out",
        dataIndex: "cashOut",
        key: "cashOut",
        render: (value: any) => <span>{Number(value).toLocaleString()}</span>,
    },
    {
        title: "Actual Cash-out",
        dataIndex: "actualCashOut",
        key: "actualCashOut",
        render: (value: any) => <span>{Number(value).toLocaleString()}</span>,
    },
    {
        title: "Machine",
        dataIndex: "machine",
        key: "machine",
    },
];
